import React from "react";
import { Switch, Route } from "react-router-dom";
import Authorization from "../../components/Authorization";

import CustomersRouter from "./Customers";
import TariffsRouter from "./Tariffs";
import InvoiceProcessingRouter from "./InvoiceProcessing";
import InvoiceGenerationRouter from "./InvoiceGeneration";
import OrderHistoryPage from "./OrderHistory/OrderHistoryPage";
import GLMainAccountRouter from "./GLMainAccounts";
import PaymentTermsRouter from "./PaymentTerms";
import OrderReprintPage from "./OrderReprint/OrderReprintPage";
import CompanyPostingPeriodsPage from "./CompanyPostingPeriods/CompanyPostingPeriodsPage";

const Billing = Authorization(["ADMIN", "FIN"]);

const AccountingRouter = () => (
  <Switch>
    <Route path="/finance/customers">{Billing(CustomersRouter)}</Route>
    <Route path="/finance/accounts">{Billing(GLMainAccountRouter)}</Route>
    <Route path="/finance/tariffs">{Billing(TariffsRouter)}</Route>
    <Route path="/finance/invoice-processing">
      {Billing(InvoiceProcessingRouter)}
    </Route>
    <Route path="/finance/invoice-generation">
      {Billing(InvoiceGenerationRouter)}
    </Route>
    <Route path="/finance/order-history">
      <OrderHistoryPage />
    </Route>
    <Route path="/finance/payment-terms">{Billing(PaymentTermsRouter)}</Route>
    <Route path="/finance/invoice-reprint">
      <OrderReprintPage />
    </Route>
    <Route path="/finance/posting-periods">
      <CompanyPostingPeriodsPage />
    </Route>
  </Switch>
);

export default AccountingRouter;
